export default class UpsertTagAttributeOptionsRequestItem  {
	/**
	 * * Номер тега на пм-е
	 */
	TagId!: number;
	/**
	 * * Название тега на Weeek
	 */
	WeeekTagName!: string;
	constructor(obj?: Partial<UpsertTagAttributeOptionsRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
